import { AGREEMENT, AGREEMENT_OBJECT, AUTH, CORE, LARVA, LARVA_WS } from 'core/datasets/action';
import { all, fork, takeEvery, takeLatest, takeLeading, throttle } from 'redux-saga/effects';
import {
    fetchAllConnections,
    fetchAllData,
    fetchAllLarvaData,
    handleQueuedActions,
    handleQueuedRequests,
    initUnitsUiNodesFetching,
} from 'smartHome/larva/saga/workers';
import { initConnections } from './workers/updateWsConnections';
import { fetchApiUnits } from './workers/fetchAllLarvaData';

export function* watchUnitDevicesRequest(): Generator {
    yield takeLeading([AGREEMENT.AGREEMENT_SELECTED], fetchAllLarvaData);
}

export function* watchWebsocketsConnectionRequest(): Generator {
    yield takeLatest(LARVA.WEBSOCKET_CONNECTIONS_REQUESTED, initUnitsUiNodesFetching);
}

export function* watchUnitDevicesApiRequest(): Generator {
    yield takeLeading(LARVA.API_UNITS_FETCH_STARTED, fetchApiUnits);
}

export function* watchToResetAllConnections(): Generator {
    try {
        yield throttle(10000, [LARVA.PUT_API_UNITS], fetchAllConnections);
    } catch (error) {
        console.error('Larva fetch all smart home connections error', { error });
    }
}

export function* watchToLarvaWebsocketConnectionErrors(): Generator {
    try {
        yield takeLeading(LARVA_WS.WS_CONNECTION_ERROR, fetchAllData);
    } catch (error) {
        console.error('Larva fetch all smart home connections error', { error });
    }
}

export function* watchToCoreNetworkStatus(): Generator {
    try {
        yield takeEvery([CORE.NETWORK_STATUS_CHANGED, CORE.APP_ACTIVE_STATUS_CHANGED], fetchAllData);
    } catch (error) {
        console.error('Larva fetch all smart home connections error', { error });
    }
}

export function* watchToFetchUnitDevices(): Generator {
    try {
        yield takeEvery(
            [AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED, AUTH.EXPIRED_TOKEN_REFRESHED],
            initUnitsUiNodesFetching,
        );
    } catch (error) {
        console.error('Larva fetch all smart home data error', { error });
    }
}

function* watchHandlingRequestsCall(): Generator {
    yield takeLeading(LARVA_WS.HANDLE_QUEDED_PENDING_REQUESTS, handleQueuedRequests);
}

function* watchActionsQueue() {
    yield takeLeading(LARVA.HANDLE_QUEUED_ACTIONS, handleQueuedActions);
}

export function* watchInitConnections(): Generator {
    yield takeEvery(LARVA_WS.INIT_WS_CONNECTION, initConnections);
}

export function* larvaSmartHomeWatcher(): Generator {
    yield all([
        fork(watchHandlingRequestsCall),
        fork(watchActionsQueue),
        fork(watchInitConnections),
        fork(watchToFetchUnitDevices),
        fork(watchToResetAllConnections),
        fork(watchUnitDevicesRequest),
        fork(watchWebsocketsConnectionRequest),
        fork(watchUnitDevicesApiRequest),
        fork(watchToLarvaWebsocketConnectionErrors),
        fork(watchToCoreNetworkStatus),
    ]);
}
